import { Formik } from "formik";
import React, { useEffect, useState, useRef, useCallback  } from 'react';
import { Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import InputField from "../InputField/InputField";
import * as Yup from "yup";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';

const ShoppingCartShipping = () => {
  const navigator = useNavigate();

  const initialVal = {
    country: "",
    //comment: "",
    //coupon: "GET50OFF",
  };

  const [cartDetails, setCartDetails] = useState(false);

    async function updateCartItems (e,itemDetails,qty){
        e.preventDefault();

        setCartDetails(false);
        itemDetails.qty+=qty;
        await AuthVerify.addTocart(itemDetails,{qty:itemDetails.qty},true).then(function(result){
            cartDetails.items=result.items;
            cartDetails.carth.totalamt=result.summary.totalamt;
            cartDetails.carth.gstamt=result.summary.gstamt;
            cartDetails.carth.grossamt=result.summary.subamt;
            setCartDetails(cartDetails);
        });
    }

    useEffect(() => {
        AuthVerify.getCartDeatils(true).then((data) => {
            setCartDetails(data)
        });
    }, [])

  return (
    <section className="main-container col1-layout">
      <div className="col-main">
        <Container className="main">
          <div className="shopping-cart-inner">
            <div className="page-content">
                {cartDetails?.carth?.shippingamt==0 ?
                  <div className="heading-counter warning text-center">
                    <i className="fa fa-truck"></i>
                      <span>
                        {" "}
                        Your cart subtotal is eligible for{" "}
                        <strong>free shipping</strong>.
                      </span>
                  </div>:
                  <div className="heading-counter warning text-center">
                    <i className="fa fa-truck"></i>
                      <span>
                        {cartDetails.carth?.shipdeldatedisplay &&
                          <span>
                            {cartDetails.carth.shipdeldatemessage}.
                          </span>
                        }
                      </span>
                  </div>
                  }
                  
              <div className="page-content checkout-page">
                {/* <h3 className="checkout-sep">Shipping Information</h3> */}
                <Formik
                  initialValues={initialVal}
                  validationSchema={Yup.object().shape({
                    // country: Yup.string().required("Country is required"),
                    //comment: Yup.string().required("Country is Required"),
                    //coupon: Yup.string().required("Country is Required"),
                  })}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    // console.log("Values", values);
                    setSubmitting(false);
                    navigator("/shopping-cart-info");
                    resetForm();
                  }}
                >
                  {(props) => {
                    const {
                      values,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      errors,
                      touched
                    } = props;
                    return (
                      <Form onSubmit={handleSubmit}>
                        {/* <div className="box-border">
                          <ul>
                            <Row>
                              <Col sm={6}>
                                <label className="required">
                                  Shipping Method
                                </label>
                                <br />
                                <label for="radio_button_1">
                                  <input
                                    type="radio"
                                    checked
                                    name="deliveryType"
                                    id="radio_button_1"
                                  />
                                  <strong> SOS Delivery Team: $5.00</strong>
                                </label>
                              </Col>
                            </Row>
                          </ul>
                        </div> 
                        <h3 className="checkout-sep">Payment Information</h3>
                        <div className="box-border">
                          <ul>
                            <li>
                              <label className="required">Payment Method</label>
                              <br />
                              <label for="radio_button_3">
                                <input
                                  type="radio"
                                  checked
                                  name="paymentMethod"
                                  id="radio_button_3"
                                />
                                <strong> Credit Card</strong>
                              </label>
                            </li>
                            <li>
                              <label for="radio_button_4">
                                <input
                                  type="radio"
                                  name="paymentMethod"
                                  id="radio_button_4"
                                />
                                <strong> Cheque / Money order</strong>
                              </label>
                            </li>
                          </ul>
                        </div>*/}
                        {/* <h3 className="checkout-sep">Order Remarks</h3>
                        <div className="box-border">
                          <ul>
                            <li className="">
                              <label className="required">
                                Write your order remarks here
                              </label>
                              <br />
                              <div style={{ float: "none" }} className="">
                                <TextareaField
                                  name="comment"
                                  value={values.comment}
                                  onChange={handleChange}
                                  Labels="Comment"
                                  className="required-entry input-text"
                                  rows="3"
                                />
                            </div>
                            </li>
                          </ul>
                        </div>*/}
                        <h3 className="checkout-sep">Order Summary</h3>
                        <div className="box-border">
                          <div className="order-detail-content table-responsive">
                            <table className="table table-bordered jtv-cart-summary">
                              <thead></thead>
                              <tbody></tbody>
                              {cartDetails.carth &&
                              <tfoot>
                                <tr>
                                  <td colSpan="2" rowspan="5">
                                    <div
                                      className="input-group mb-3"
                                      style={{ display: "flex", width: "80%" }}
                                    >
                                      <div style={{ width: "100%" }}>
                                        <InputField
                                          Placeholder="Promo Code Here"
                                          Type="text"
                                          Name="coupon"
                                          value={values.coupon}
                                          onChange={handleChange}
                                          className="input form-control"
                                        />
                                      </div>
                                      {
                                        // <input type="text" id="coupon" name="coupon" value="" title="coupon"
                                        //     className="input form-control" placeholder="Promo Code Here" />
                                      }
                                      {/* <div className="input-group-append"> */}
                                      <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        style={{
                                          borderRadius: "0 3px 3px 0",
                                          color: "#fff",
                                          background: "#f07c2a",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.5px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        Apply
                                      </button>
                                      {/* </div> */}
                                    </div>
                                  </td>
                                  <td colSpan="3">Subtotal</td>
                                  <td colSpan="2">S${(cartDetails?.carth?.grossamt??0).toFixed(3)}</td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    <strong>Discount</strong>
                                  </td>
                                  <td colSpan="2">
                                    <strong>S${(cartDetails?.carth?.discamt??0).toFixed(3)}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    <strong>Shipping Amount</strong>
                                  </td>
                                  <td colSpan="2">
                                    <strong>S${(cartDetails?.carth?.shippingamt??0).toFixed(3)}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    <strong>GST</strong>
                                  </td>
                                  <td colSpan="2">
                                    <strong>S${(cartDetails?.carth?.gstamt??0).toFixed(3)}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    <strong>Grand Total</strong>
                                  </td>
                                  <td colSpan="2">
                                    <strong>S${(cartDetails?.carth?.totalamt??0).toFixed(3)}</strong>
                                  </td>
                                </tr>
                              </tfoot>
                              }
                            </table>
                          </div>
                        </div>
                        <div className="cart_navigation">
                          <Link
                            to="/shopping-cart"
                            style={{ padding: "0px", border: "none" }}
                          >
                            <button
                              className="button continue-shopping"
                              title="Continue shopping"
                              type="button"
                            >
                              <span>Previous</span>
                            </button>
                          </Link>
                          <button
                            className="button btn-proceed-checkout"
                            title="Proceed to Checkout"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            <span>Proceed</span>
                          </button>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default ShoppingCartShipping;
